import YpCreateForm from './YpCreate';
export default YpCreateForm;
